import ButtonPrimary from "components/Button/ButtonPrimary";
import React from "react";

const Page404: React.FC = () => (
  <div className="nc-Page404">
    <div className="container relative py-16 lg:py-20">
      {/* HEADER */}
      <header className="text-center max-w-2xl mx-auto space-y-7">
        
        <span className="block text-sm text-neutral-800 sm:text-base dark:text-neutral-200 tracking-wider font-medium">
          {`Page introuvable.`}
        </span>
        <ButtonPrimary href="/" className="mt-4">
          Retourner à l'Accueil
        </ButtonPrimary>
      </header>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
    </div>
  </div>
);

export default Page404;
